import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { BudgetValidationActionCode } from './budgetvalidation.models';

type Props = {
  open: boolean;
  actioncode: BudgetValidationActionCode;
  onClose: () => void;
  onConfirm: (reason: string, remarks: string) => void;
};
type State = { reason: string; remarks: string };

export default class ValidationDecisionDialog extends React.PureComponent<Props, State> {
  state: State = { reason: '', remarks: '' };

  componentDidUpdate(prev: Props) {
    if (this.props.open && (!prev.open || prev.actioncode !== this.props.actioncode)) {
      this.setState({ reason: '', remarks: '' });
    }
  }

  render() {
    const { actioncode } = this.props;
    const title = actioncode === 'VALIDATE'
      ? 'Validate Consolidated Budget'
      : actioncode === 'REOPEN'
        ? 'Reopen Budget Validation'
        : 'Return Budget to Consolidation';
    return (
      <Dialog open={this.props.open} onClose={this.props.onClose} fullWidth maxWidth="sm">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            {actioncode === 'RETURN' && (
              <Typography variant="body2" color="text.secondary">
                This decision returns the budget to Budget Consolidation for review.
              </Typography>
            )}
            <TextField
              required multiline minRows={3}
              label={actioncode === 'VALIDATE' ? 'Validation Rationale' : 'Reason'}
              value={this.state.reason}
              onChange={e => this.setState({ reason: e.target.value })}
            />
            <TextField
              multiline minRows={2} label="Remarks"
              value={this.state.remarks}
              onChange={e => this.setState({ remarks: e.target.value })}
            />
            {actioncode === 'VALIDATE' && (
              <Typography variant="caption" color="text.secondary">
                DG Validation records management acceptance. It does not create a budget version; versioning occurs at CA adoption.
              </Typography>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button variant="contained" disabled={!this.state.reason.trim()}
            onClick={() => this.props.onConfirm(this.state.reason.trim(), this.state.remarks)}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
